"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyableText = void 0;
var _react = _interopRequireDefault(require("react"));
var _CopyableTextContainer = require("b2b-components/core/components/CopyableText/CopyableTextContainer.types");
var _ButtonIcon = require("b2b-components/theme/components/ButtonIcon");
var _Icon = require("b2b-components/theme/components/Icon");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
var _Content = require("./Content");
var _CopyButton = require("./CopyButton");
require("./CopyableText.scss");
const CopyableText = _ref => {
  let {
    children,
    value,
    deviceType,
    isTooltipEnabled,
    isTriggerCopyOnTextClick,
    isCopyButtonVisible,
    getTooltipText,
    onCopyableTextMouseEnter,
    onCopyableTextMouseLeave,
    onCopyButtonTransitionEnd,
    className,
    buttonSize = _ButtonIcon.BUTTON_ICON_SIZE.small,
    buttonTouchscreenVisibility = _CopyableTextContainer.COPYABLE_TEXT_BUTTON_VISIBILITY.always,
    buttonVisibility = _CopyableTextContainer.COPYABLE_TEXT_BUTTON_VISIBILITY.hover,
    iconName = _Icon.ICON_NAME.copy
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-CopyableText', {
    'cds-CopyableText--DesktopVisible': buttonVisibility === _CopyableTextContainer.COPYABLE_TEXT_BUTTON_VISIBILITY.always,
    'cds-CopyableText--MobileVisible': buttonTouchscreenVisibility === _CopyableTextContainer.COPYABLE_TEXT_BUTTON_VISIBILITY.always,
    'cds-CopyableText--Extended': isTriggerCopyOnTextClick
  }, className);
  const contentClassName = (0, _classnames.default)('cds-CopyableText-Content', {
    [`cds-CopyableText-Content--${(0, _upperCase.upperCaseFirst)(buttonSize)}`]: buttonSize
  });
  let valueToCopy = value;
  if (!value && typeof children === 'string') {
    valueToCopy = children;
  }
  if (!valueToCopy) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("span", {
    className: rootClassName,
    onMouseEnter: onCopyableTextMouseEnter,
    onMouseLeave: onCopyableTextMouseLeave
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-CopyableText-Wrapper"
  }, isTriggerCopyOnTextClick ? /*#__PURE__*/_react.default.createElement(_Content.Content, {
    className: contentClassName,
    getTooltipText: getTooltipText,
    value: valueToCopy
  }, children) : /*#__PURE__*/_react.default.createElement("span", {
    className: contentClassName
  }, children), /*#__PURE__*/_react.default.createElement(_CopyButton.CopyButton, {
    buttonSize: buttonSize,
    deviceType: deviceType,
    getTooltipText: getTooltipText,
    iconName: iconName,
    isCopyButtonVisible: isCopyButtonVisible,
    isTooltipEnabled: isTooltipEnabled,
    onTransitionEnd: onCopyButtonTransitionEnd,
    value: valueToCopy
  })));
};
exports.CopyableText = CopyableText;
//# sourceMappingURL=CopyableText.js.map